import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import REQUIRED_FIELDS from '../../events/REQUIRED_FIELDS';
import ChartLoader from '../../states/_charts/ChartLoader';
import DonutChart from '../../states/_charts/DonutChart';
import colors from 'tailwindcss/colors';

export default function EventResponseYear(props) {
  const { state, network, schoolStart, schoolEnd, subtitle } = props;

  const responses = [
    'Yes',
    'Maybe',
    'Pending',
    'No',
    'No invites'
  ];

  const responseMap = {
    'Yes': {
      // numberOfInvitationsPending: 0,
      numberOfInvitationsYes: {
        $gte: 1
      },
      // numberOfInvitationsMaybe: 0,
      // numberOfInvitationsNo: 0
    },
    'Maybe': {
      // numberOfInvitationsPending: 0,
      numberOfInvitationsYes: 0,
      numberOfInvitationsMaybe: {
        $gte: 1
      },
      // numberOfInvitationsNo: 0
    },
    'Pending': {
      numberOfInvitationsPending: {
        $gte: 1
      },
      numberOfInvitationsYes: 0,
      numberOfInvitationsMaybe: 0,
      // numberOfInvitationsNo: 0
    },
    'No': {
      numberOfInvitationsPending: 0,
      numberOfInvitationsYes: 0,
      numberOfInvitationsMaybe: 0,
      numberOfInvitationsNo: {
        $gte: 1
      }
    },
    'No invites': {
      numberOfInvitationsPending: 0,
      numberOfInvitationsYes: 0,
      numberOfInvitationsMaybe: 0,
      numberOfInvitationsNo: 0
    }
  };

  const requests = responses.map(function(response) {
    return {
      label: response,
      events: useConnect('event.find', {
        where: {
          eager: {
            $aggregations: [
              'Pending',
              'Yes',
              'Maybe',
              'No'
            ].map(function(response) {
              return {
                type: 'count',
                alias: `numberOfInvitations${response}`,
                relation: 'invitations',
                $where: {
                  response: response
                }
              };
            }),
            $where: {
              $and: REQUIRED_FIELDS.$and,
              activityId: {
                $null: false
              },
              // networkId: network?.id,
              site: {
                $where: {
                  state: {
                    $ilike: state
                  }
                }
              },
              createdAt: {
                $lte: schoolEnd,
                $gte: schoolStart
              }
            },
            $having: {
              ...responseMap[response]
            }
          }
        },
        pagination: {
          pageSize: 1
        }
      })
    };
  });

  const loading = _.reduce(requests, function(result, request) {
    return result || request.events.state === PayloadStates.FETCHING;
  }, false)

  if (loading) {
    return (
      <ChartLoader
        title="Events by Partner Status"
        subtitle={subtitle || 'For school year'}
      />
    );
  }

  const series = requests.map(r => r.events.meta.totalCount);
  const labels = requests.map(r => r.label);

  return (
    <DonutChart
      title="Events by Partner Status"
      subtitle={subtitle || 'For school year'}
      labels={labels}
      series={series}
      colors={[
        colors.emerald['400'],
        colors.lime['400'],
        colors.yellow['400'],
        colors.red['400'],
        colors.blue['400']
      ]}
    />
  );
}
